exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".route__wrapper--2BbYl {\n\twidth: 100vw;\n\theight: 100vh;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "route__wrapper--2BbYl"
};